import { render, staticRenderFns } from "./FormBenefitInser.vue?vue&type=template&id=8dbf624a&"
import script from "./FormBenefitInser.vue?vue&type=script&lang=js&"
export * from "./FormBenefitInser.vue?vue&type=script&lang=js&"
import style0 from "./FormBenefitInser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports